import { Link } from "react-router-dom";
import { Headphones, Sparkles } from "lucide-react";
import { Split, Arrow } from "@/components/hm/Basics";
import { useResourceStatus, isVisible } from "@/lib/resources";

const BLOCKS = [
  { icon: Sparkles, title: "Entender lo que te está pasando", to: "/entender-lo-que-te-esta-pasando", cta: "Leer ahora", id: "understand",
    text: "Una explicación clara y sencilla para comprender por qué tu sensibilidad se está activando y cómo interpretar este cambio interno sin miedo." },
  { icon: Headphones, title: "Práctica guiada de introspección (8–10 min)", to: "/practica-guiada", cta: "Escuchar práctica", id: "practice",
    text: "Una experiencia sencilla y acompañada para escuchar lo que se mueve dentro de ti sin prisa." },
];


export const WelcomeModule = () => {
  const status = useResourceStatus();
  const blocks = BLOCKS.filter((b) => b.id !== "practice" || isVisible(status, "practica-introspeccion"));
  return (
    <section className="sec welcome-mod" id="bienvenida" data-testid="landing-welcome-module">
      <div className="wrap">
        <div className="sec-head">
          <span className="eyebrow">Módulo de bienvenida</span>
          <Split className="hm-h1" text="Módulo de bienvenida —" serif="Lo que sientes tiene sentido" data-testid="welcome-module-title" />
          <p className="lead rv" data-testid="welcome-module-intro">
            Este módulo es un espacio para entender con claridad lo que te está pasando por dentro. Si te sientes vacío, desconectado, confundido o más sensible de lo habitual, no es un error: es tu interior reorganizándose. Tu corazón está empezando a pedirte coherencia, verdad y dirección.
            <br /><br />Aquí encontrarás una explicación sencilla y profunda para comprender este momento sin miedo, y para empezar a escucharte de una forma nueva.
            <br /><br />No estás roto. Estás cambiando. Y lo que sientes tiene sentido.
          </p>
        </div>
        <div className="wm-blocks" style={blocks.length === 1 ? { gridTemplateColumns: "1fr" } : undefined}>
          {blocks.map((it, i) => (
            <article key={it.id} className="wm-block rv" style={{ "--d": `${i * 90}ms` }} data-testid={`welcome-module-block-${it.id}`}>
              <span className="card-ico"><it.icon /></span>
              <h3>{it.title}</h3>
              <p>{it.text}</p>
              <Link to={it.to} className="btn btn-primary btn-sm wm-btn" data-testid={`welcome-module-cta-${it.id}`}>{it.cta} <Arrow /></Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
